import type { Role } from '@/features/auth/roles';

/**
 * Dashboard tile labels per role, copied from the Admin v2 screenshots (super
 * admin from the walkthrough text). Labels only: values stay empty until each
 * area is connected to the API. No demo figures are shipped.
 */
export const DASHBOARD_TILES: Record<Role, string[]> = {
  front_desk: ['Waiting now', 'Booked today', 'Average wait', 'Cash in drawer'],
  doctor: [
    'My patients today',
    'Results to review',
    'Teleconsults',
    'My inbox',
  ],
  locum: ['My patients today', 'My next shift', 'Contract ends', 'Attendance'],
  mental_health: [
    'Sessions today',
    'Screening flags',
    'Compartment opens',
    'No-shows this month',
  ],
  // RL-1675: only tiles with data (NurseDashboard).
  nurse: ['Open chats', 'Waiting for vitals'],
  lab: ['To collect today', 'At the lab', 'Results in', 'Home visits'],
  dispenser: [
    'Signed, to dispense',
    'Dispensed today',
    'Out of stock',
    'Deliveries',
  ],
  finance: [
    'Claims due ≤ 24 h',
    'Queried',
    'Outstanding',
    'Unapplied remittance',
  ],
  clinic_manager: [
    'Doctors on roster',
    'Services',
    'Approvals waiting',
    'Audit events today',
  ],
  super_admin: [
    'Staff accounts',
    'Group outstanding',
    'Integrations',
    'Audit events',
  ],
};
